import { Injectable } from '@angular/core';
import {
  SearchResultViewModel,
  SearchViewModel,
} from '@search/shared/models/search-view.model';
import { ProductAnalyticsService } from '@usf/ngrx-product';
import { ProductSummary } from '@usf/product-types';
import { UsfProductCardModeEnum } from '@shared/constants/usf-product-card-mode.enum';
import { Product } from '@shared/models/product.model';

@Injectable({
  providedIn: 'root',
})
export class ProductCompareAnalyticsService {
  constructor(private analyticsService: ProductAnalyticsService) {}

  trackProductCompareSubmit(
    products: Product[],
    searchResults: SearchViewModel,
    mode: UsfProductCardModeEnum,
    originalProductNumber: number,
  ) {
    this.analyticsService.trackProductCompareSubmit(
      this.extractSearchResultsTrackingData(
        products,
        searchResults,
        mode,
        originalProductNumber,
      ),
    );
  }

  trackUserStartingProductCompare() {
    this.analyticsService.trackUserStartingProductCompare();
  }

  trackUserStartingProductCompareOnSearchForSubs(
    replacementBaseProduct: SearchResultViewModel,
  ) {
    this.analyticsService.trackUserStartingProductCompareOnSearchForSubs(
      replacementBaseProduct.summary.divisionNumber,
      replacementBaseProduct.summary.productNumber,
      replacementBaseProduct.trackingAttributes,
    );
  }

  extractSearchResultsTrackingData(
    productsData: Product[],
    searchResults: SearchViewModel,
    mode: UsfProductCardModeEnum,
    originalProductNumber: number,
  ): any[] {
    const isSearchForSubOrReplace =
      mode === UsfProductCardModeEnum.exceptionSearch ||
      mode === UsfProductCardModeEnum.replacementSearch;

    const products = [];
    let product: any;
    let substitute: any;

    productsData.forEach(productData => {
      if (!!productData && !!productData.summary) {
        if (productData.hasAlternative) {
          product = {
            divisionApn: `${productData.summary.divisionNumber}-${productData.productNumber}`,
            attributes: productData.trackingAttributes,
            exceptionView: '1',
            exceptionNumberOfSubs:
              productData.inventory?.substituteProducts?.length > 0 &&
              productData.hasAlternative
                ? 1
                : 0,
          };
          const subsDivision =
            productData.alternative?.product.summary.divisionNumber;
          const subsProductNumber =
            productData.alternative?.product.productNumber;
          substitute = {
            divisionApn: `${subsDivision}-${subsProductNumber}`,
            attributes: productData.alternative?.product.trackingAttributes,
            substitutionView: '1',
            substitutionParentApn:
              productData.summary.divisionNumber +
              '-' +
              productData.productNumber,
            substituteType: !!productData.alternative.substituteInfo
              ? productData.alternative.substituteInfo.substituteType
              : productData.alternative?.type,
            substitutePriority: productData.alternative?.substituteInfo
              ? productData.alternative?.substituteInfo.substitutePriority
              : 1,
          };
          products.push(product);
          products.push(substitute);
        } else {
          product = {
            divisionApn: `${productData.summary.divisionNumber}-${productData.productNumber}`,
            attributes: productData.trackingAttributes,
            productPosition: isSearchForSubOrReplace
              ? this.getProductPositionWithAlternatives(
                  searchResults,
                  productData.summary,
                  originalProductNumber,
                )
              : this.getProductPosition(searchResults, productData.summary),
          };
          products.push(product);
        }
      }
    });

    return products;
  }

  private getProductPosition(
    searchResults: SearchViewModel,
    product: ProductSummary,
  ) {
    return (
      searchResults.listProducts.findIndex(
        searchResult => searchResult.productNumber === product.productNumber,
      ) + 1
    );
  }

  private getProductPositionWithAlternatives(
    searchResults: SearchViewModel,
    product: ProductSummary,
    originalProductNumber: number,
  ) {
    if (product.productNumber === originalProductNumber) {
      return 1;
    }
    return (
      searchResults.listProducts.findIndex(
        searchResult => searchResult.productNumber === product.productNumber,
      ) + 2
    );
  }
}
